var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2 16.5v.5a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5v-6a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeWidth: 1.5,
    d: "M19 6.5v-.16a3.537 3.537 0 0 0-4.25-3.465l-4.25.875-4.508.928A5 5 0 0 0 2 9.575V12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6 17.5h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#102262",
    d: "M22 16.5v.75h.75v-.75H22Zm-3.5-4.25a.75.75 0 0 0 0-1.5v1.5Zm2.75-.75v5h1.5v-5h-1.5Zm.75 4.25h-4.5v1.5H22v-1.5Zm-4.5-3.5h1v-1.5h-1v1.5Zm0 3.5A1.75 1.75 0 0 1 15.75 14h-1.5a3.25 3.25 0 0 0 3.25 3.25v-1.5ZM15.75 14c0-.966.784-1.75 1.75-1.75v-1.5A3.25 3.25 0 0 0 14.25 14h1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.5 14h.2"
  })));
};
export default SvgWallet;